<template lang="pug">
BriqPanel.price-discount-panel
  h2.mb-S Price
  PriceAndTax(
    :product="product"
    :selectedResource="selectedResource"
    :vuelidate="vuelidate"
    :taxOptions="taxOptions"
    :disabled="disabled"
    )
  LedgerAccounts(
    v-if="showAccountingFields"
    :product="product"
    :ledgerAccounts="ledgerAccounts"
    :disabled="disabled"
    )
  AdvancedPricingOptions(
    :product="product"
    :disabled="disabled"
    :deals="deals"
    :selectedResource="selectedResource"
    :resourceSegments="resourceSegments"
    :vuelidate="vuelidate"
    )
</template>

<script>
import PriceAndTax from './PriceConfigurationPanel/PriceAndTax.vue'
import LedgerAccounts from './PriceConfigurationPanel/LedgerAccounts.vue'
import AdvancedPricingOptions from './PriceConfigurationPanel/AdvancedPricingOptions.vue'

export default {
  name: 'PriceConfigurationPanel',
  components: {
    PriceAndTax,
    LedgerAccounts,
    AdvancedPricingOptions,
  },
  props: {
    product: { type: Object, required: true },
    vuelidate: { type: Object, required: true },
    disabled: Boolean,
    taxOptions: { type: Array, required: true },
    ledgerAccounts: { type: Array, required: true },
    showAccountingFields: Boolean,
    selectedResource: Object,
    deals: Array,
    resourceSegments: Array,
  },
}
</script>

<style lang="stylus" scoped>
h2
  margin-botttom 20px
</style>
